import { useEffect, useState } from "react";
import { useAppServices } from "../../../../../../hook/services";
import DataTable from "../../../components/DataTable";
import AddButtonModal from "./AddButtonModal";
import Swal from "sweetalert2";

const CustomPageButtonsTab = ({ app, handleRefresh }) => {
  const AppService = useAppServices();
  const [copy_buttons, setCopyButtons] = useState(app?.copy_buttons || []);

  useEffect(() => {
    setCopyButtons(app?.copy_buttons || []);
  }, [app]);

  const handleDelete = async (removeIndex) => {
    const result = await Swal.fire({
      title: "Delete Button?",
      text: "This button will be removed from the app",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      // Remove object using slice
      let copyButtonsData = [
        ...copy_buttons.slice(0, removeIndex),
        ...copy_buttons.slice(removeIndex + 1),
      ];

      const payload = {
        _id: app._id,
        copy_buttons: copyButtonsData,
      };

      const { response } = await AppService.apps.update({ payload });
      if (response) {
        handleRefresh();
        Swal.fire("Deleted!", "Field has been removed.", "success");
      }
    }
  };

  const columns = [
    { label: "Button Text", accessor: "button_text" },
    { label: "Copy Url", accessor: "copy_url" },
    {
      label: "Actions",
      accessor: "actions",
      renderCell: (row, index) => (
        <div className="d-flex gap-2">
          <AddButtonModal
            initialData={row}
            app={app}
            updateIndex={index}
            handleRefresh={handleRefresh}
          />
          <button
            className="btn btn-outline-danger btn-sm"
            onClick={() => handleDelete(index)}
          >
            <i className="bi bi-trash"></i>
          </button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="d-flex justify-content-end align-items-center mb-3">
        <AddButtonModal handleRefresh={handleRefresh} app={app} />
      </div>
      <DataTable columns={columns} data={copy_buttons} entriesPerPage={10} />
    </div>
  );
};

export default CustomPageButtonsTab;
